/*
 * Phone product gallery: native swiping instead of the Slick slider.
 *
 * On phones the photos become a row the phone scrolls itself, so swipes
 * respond instantly even while the page is still busy loading. The dots
 * under the photos keep the theme's existing look. Desktop is unchanged.
 *
 * Load this right after theme.js with "defer", so it runs before the theme
 * starts its sections.
 */
(function ($) {
  if (!$ || !window.theme || !theme.Product || !theme.variables) return;

  var proto = theme.Product.prototype;
  var originalCreate = proto.createMediaCarousel;
  var originalDestroy = proto.destroyMediaCarousel;
  var originalShowVariantMedia = proto.showVariantMedia;
  var phoneQuery = window.matchMedia(theme.variables.mediaQuerySmall);

  proto.createMediaCarousel = function () {
    if (!phoneQuery.matches) return originalCreate.apply(this, arguments);
    if (this.isCarouselActive) return;

    var $group = $(this.selectors.productMediaGroup, this.$container);
    if (!$group.length) return;

    var $slides = $group
      .children(this.selectors.productMediaFlexWrapper)
      .not('.' + this.classes.mediaFlexWrapperHidden);
    if ($slides.length < 2) return;

    var group = $group[0];
    this.isCarouselActive = true;
    this.isNativeCarousel = true;
    $group.addClass('is-native-carousel');
    group.scrollLeft = 0;

    // Dots: same markup and classes the theme's dot styles already target
    var $dotsHolder = $(this.selectors.slickDots, this.$container);
    var $list = $('<ul class="slick-dots" aria-hidden="true"></ul>');
    $slides.each(function (i) {
      $list.append(i === 0 ? '<li class="slick-active"></li>' : '<li></li>');
    });
    $dotsHolder.empty().append($list);

    var $dots = $list.children();
    var current = 0;
    var pending = false;

    this.nativeCarouselScroll = function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        var step = $slides[1].offsetLeft - $slides[0].offsetLeft || group.clientWidth;
        var index = Math.min(
          $slides.length - 1,
          Math.max(0, Math.round(group.scrollLeft / step))
        );
        if (index !== current) {
          $dots.eq(current).removeClass('slick-active');
          $dots.eq(index).addClass('slick-active');
          current = index;
        }
      });
    };

    group.addEventListener('scroll', this.nativeCarouselScroll, { passive: true });
  };

  proto.destroyMediaCarousel = function () {
    if (!this.isNativeCarousel) return originalDestroy.apply(this, arguments);

    var $group = $(this.selectors.productMediaGroup, this.$container);
    if ($group.length) {
      $group[0].removeEventListener('scroll', this.nativeCarouselScroll);
      $group.removeClass('is-native-carousel');
      $group[0].scrollLeft = 0;
    }
    $(this.selectors.slickDots, this.$container).empty();

    this.isNativeCarousel = false;
    this.isCarouselActive = false;
  };

  // When a shopper picks a variant with its own photo, scroll to that photo
  proto.showVariantMedia = function (evt) {
    var filtered = this.mediaAltFilter && this.mediaAltFilter.isFiltered;

    if (this.isNativeCarousel && !filtered && evt.variant && evt.variant.featured_media) {
      var mediaId = this.settings.sectionId + '-' + evt.variant.featured_media.id;
      var $media = $(
        this.selectors.productMediaWrapper + '[data-media-id="' + mediaId + '"]',
        this.$container
      );
      var slide = $media.closest(this.selectors.productMediaFlexWrapper)[0];
      var group = $(this.selectors.productMediaGroup, this.$container)[0];

      if (slide && group) {
        group.scrollBy({
          left: slide.getBoundingClientRect().left - group.getBoundingClientRect().left,
          behavior: 'smooth'
        });
      }
    }

    return originalShowVariantMedia.apply(this, arguments);
  };
})(window.jQuery);